import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../hook-utils';
import { CallState, canQueueResume, canRetrieveCall, Media } from '../model';
import { actions } from '../store';
import { getActiveDevice } from '../store/reducers';
import { selectMyAccess, selectMyDevices, selectMyself } from '../store/reducers/config';
import { selectExtension } from '../store/reducers/queueAgents';
import { Menu, MenuDivider, MenuItem, MenuTarget } from './Menu';
import { ReactComponent as RetrieveIcon } from './icons/callcontrol/Retrieve.svg';
import { ReactComponent as PreviewIcon } from './icons/callcontrol/Preview.svg';
import { ReactComponent as EditIcon } from './icons/callcontrol/Edit.svg';
import { ReactComponent as DeleteIcon } from './icons/callcontrol/Delete.svg';

export type MediaMenuState = { target: MenuTarget, items: Media[], onPreview?(selected: Media): void }

export default function MediaMenu({ state: { items, target, onPreview }, onClose }: { state: MediaMenuState, onClose(): void }) {
  const dispatch = useDispatch()
  const devices = useSelector(selectMyDevices)
  const access = useSelector(selectMyAccess)
  const myId = useSelector(selectMyself)
  const extension = useSelector(s => myId && selectExtension(s, myId))

  if (!devices || !dispatch || !items || !myId || !extension || items.length === 0) { return null }

  const item = items.length === 1 ? items[0] : undefined
  const device = item ? getActiveDevice(item, devices.devices, devices.primaryDevice) : devices.primaryDevice

  const retrieveShow = !access.isLyncLicensed
  const retrieveStatus = canRetrieveCall(items, extension.status)

  const previewShow = onPreview !== undefined && item !== undefined && item.mediaType !== 'VM' && item.mediaType !== 'CALL'

  const resumeShow = canQueueResume(items, extension.status)
  const editShow = !access.isLyncLicensed
  let editStatus = item ? devices.devices.findIndex((d) => d.number === item.deviceId) > -1 ||
    devices.devices.findIndex((d) => d.number === item.preferredExtn) > -1 ||
    devices.devices.findIndex((d) => d.number === item.queueId) > -1 : false

  if (!editStatus && item) {
    editStatus = item.extensionsWaitingForWrapup.findIndex((x) => devices.devices.findIndex((d) => d.number === x) > -1) > -1
  }

  const priorityShow = false  // on hold for now
  const priorityEnabled = items.filter(x => x.status !== CallState.Queueing).length === 0

  const clidShow = access.features.callShowCLID || !access.isLyncLicensed
  const clidStatus = item && item.clid === ''
  const killShow = access.features.queueItemsKill && !access.isLyncLicensed

  return <Menu open={true} onClose={onClose} target={target}>
    {retrieveShow && <MenuItem onClick={() => device && dispatch(actions.ccQueuePickup(myId.id, items))} disabled={!retrieveStatus}>
      <RetrieveIcon className={'icon'} />Retrieve
      </MenuItem>
    }
    {previewShow && <MenuItem onClick={() => item && onPreview && onPreview(item)} disabled={!retrieveStatus}>
      <PreviewIcon className={'icon'} />Preview
      </MenuItem>
    }
    {priorityShow && <MenuItem disabled={!priorityEnabled} onClick={() => device && dispatch(actions.ccMedaiPriorityChange(items.map(x => x.id)))}>
      Priority
    </MenuItem>}
    {(retrieveShow || retrieveShow) && <MenuDivider />}
    {resumeShow && <MenuItem onClick={() => device && dispatch(actions.ccQueueResume(myId.id, items))}>
      Unpark
      </MenuItem>
    }
    {resumeShow && <MenuDivider />}
    {editShow && <MenuItem onClick={() => { if (item) dispatch(actions.openAgentView(item.id, item.status === CallState.WaitingForWrapup ? 'wrapups' : '')) }} disabled={!editStatus || !item}>
      <EditIcon className={'icon padded'} />{item && item.status === CallState.WaitingForWrapup ? 'Wrapup Call' : 'Edit Call Note'}
    </MenuItem>}
    {editShow && <MenuDivider />}
    {clidShow && <MenuItem onClick={() => dispatch(actions.featchMediaClidRequest(items.map(x => x.id)))} disabled={!clidStatus}>
      Show CLID
      </MenuItem>}
    {killShow && <MenuItem onClick={() => dispatch(actions.ccKill(items.map(x => x.id)))}>
      <DeleteIcon className={'icon'} />Kill
      </MenuItem>}
  </Menu>
}
